import React, { ReactNode } from 'react';

export type TableThemeType = 'light' | 'dark';
const Table = ({
  children,
  style,
  theme = 'dark',
}: {
  children?: ReactNode;
  style?: any;
  theme?: TableThemeType;
}): JSX.Element => {
  // NOTE: Styles could be elevated to utility CSS classes
  const tableStyles = {
    width: '100%',
    minWidth: '100%',
    overflow: 'auto',
    background: (theme === 'light') ? 'white' : 'transparent',
    borderRadius: '6px',
    borderColor: (theme === 'light') ? 'black' : 'rgba(255,255,255,0.25)',
    borderWidth: '1px',
    borderStyle: 'solid',
    color: (theme === 'light') ? 'black' : 'white',
  };
  return (
    <div style={tableStyles}>
      <table
        className="f-small"
        style={{
          ...style,
          width: '100%',
          minWidth: '100%',
        }}
      >
        {children}
      </table>
    </div>
  );
};

export default Table;
